import { gql } from 'apollo-angular';

export const SetContextFunnelDocument = gql`
  mutation setContextFunnel($funnelId: Int!) {
    setContextFunnel(funnelId: $funnelId)
  }
`;
